/**
 * Standard date formatter for the entire project.
 * Always returns DD/MM/YYYY format.
 * @param {string|Date} d - date string or Date object
 * @returns {string} formatted date e.g. 14/04/2026
 */
export const formatDate = (d) => {
  if (!d) return '-';
  const s = String(d).trim();
  // Already DD/MM/YYYY
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s;
  const dt = new Date(s);
  if (isNaN(dt.getTime())) return s;
  const day = String(dt.getDate()).padStart(2, '0');
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Format date+time for audit fields (Created/Modified).
 * Returns DD/MM/YYYY, HH:MM AM/PM
 * @param {string|Date} d
 * @returns {string} e.g. 14/04/2026, 02:30 PM
 */
export const formatDateTime = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '-';
  const date = formatDate(dt);
  const time = dt.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${date}, ${time}`;
};
